import { render } from "./bill-center-detail.vue?vue&type=template&id=ef5c9628&scoped=true&ts=true"
import script from "./bill-center-detail.vue?vue&type=script&lang=ts"
export * from "./bill-center-detail.vue?vue&type=script&lang=ts"

import "./bill-center-detail.vue?vue&type=style&index=0&id=ef5c9628&scoped=true&lang=stylus"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef5c9628"]])

export default __exports__